import plugin from './theme';

export * from './theme';

export default plugin;
